var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.564 16.888a6.362 6.362 0 003.71-1.196l3.935 3.935a.946.946 0 00.68.274c.54 0 .922-.415.922-.946a.901.901 0 00-.266-.664l-3.91-3.918a6.358 6.358 0 001.312-3.869c0-3.51-2.872-6.383-6.383-6.383-3.503 0-6.383 2.864-6.383 6.383 0 3.512 2.872 6.384 6.383 6.384zm0-1.378c-2.74 0-5.005-2.266-5.005-5.006 0-2.739 2.266-5.005 5.005-5.005 2.74 0 5.005 2.266 5.005 5.005 0 2.74-2.266 5.006-5.005 5.006z"
  })));
}
export default SvgSearch;